<template>
    <div :dir="isRtl ? 'rtl' : 'ltr'">
      <h2 class="content-heading border-bottom mb-4 pb-2">
        {{ $t('titel_transaction_details') }}
      </h2>
  
      <p class="text-muted">
        <i class="fa fa-info me-1"></i>
        {{ transactionText }}
      </p>
    </div>
  </template>
  
  <script>
  import { useI18n } from 'vue-i18n'
  
  export default {
    props: {
      debtorType: {
        type: String,
        required: true
      },
      creditorType: {
        type: String,
        required: true
      }
    },
    setup(props) {
      const { t, te, locale } = useI18n();
  
      const key = `transactions.${props.debtorType}.${props.creditorType}`;
      const transactionText = te(key) ? t(key) : t('transactions.unsupported');
  
      const isRtl = locale.value === 'ar';
  
      return {
        transactionText,
        isRtl
      };
    }
  };
  </script>
  